import { useState, useEffect, useLayoutEffect, useRef } from 'react';

export const useMediaQuery = query => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
};

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [ref, handler]);
};


export const useElementClientRect = () => {
  const ref = useRef(null);
  const [elementClientRect, setElementClientRect] = useState({});

  const setValues = () => {
    if (!ref.current) return;
    const clientRect = ref.current.getBoundingClientRect();
    setElementClientRect(clientRect);
  };

  useLayoutEffect(() => {
    setValues();
  }, [ref.current]);

  useEffect(() => {
    window.addEventListener('resize', setValues);
    return () => window.removeEventListener('resize', setValues);
  }, [ref.current]);

  return [ref, elementClientRect];
};

